import React from 'react';
import { HeroSection } from './components/HeroSection';
import { HookSection } from './components/HookSection';
import { ProblemSection } from './components/ProblemSection';
import { WhyItFailedSection } from './components/WhyItFailedSection';
import { MechanismSection } from './components/MechanismSection';
import { DeliverablesSection } from './components/DeliverablesSection';
import { WhoIsItForSection } from './components/WhoIsItForSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { ProofSection } from './components/ProofSection';
import { FAQSection } from './components/FAQSection';
import { OfferSection } from './components/OfferSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-tactical-dark selection:bg-accent/30 selection:text-white" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <HookSection data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <WhyItFailedSection data-id="element-5" />
        <MechanismSection data-id="element-6" />
        <DeliverablesSection data-id="element-7" />
        <WhoIsItForSection data-id="element-8" />
        <HowItWorksSection data-id="element-9" />
        <ProofSection data-id="element-10" />
        <FAQSection data-id="element-11" />
        <OfferSection data-id="element-12" />
      </main>

      <Footer data-id="element-13" />
    </div>;
}